import { render, staticRenderFns } from "./MagicCubeSetting.vue?vue&type=template&id=269ee971&scoped=true"
import script from "./MagicCubeSetting.vue?vue&type=script&lang=js"
export * from "./MagicCubeSetting.vue?vue&type=script&lang=js"
import style0 from "./MagicCubeSetting.vue?vue&type=style&index=0&id=269ee971&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269ee971",
  null
  
)

export default component.exports